<template>
  <vs-col vs-w="12" class="mt-2">
    <vs-row vs-w="12">
      <label for="" class="vs-input--label">{{label}}</label>
    </vs-row>

    <vs-row vs-w="12" v-if="limit">

      <vs-col vs-lg="10" vs-sm="9" vs-xs="10">
        <vs-row vs-w="12">
          <div vs-justify="flex-start">
            <vs-row vs-w="12">
              <label for="" class="vs-input--label">From</label>
            </vs-row>
            <vs-row vs-w="12" vs-justify="flex-start">
              <hours-dropdown :from-hour="0" :to-hour="23" v-model="fromHours" />
              <span class="mx-2 my-auto">:</span>
              <minutes-dropdown :from-minute="0" :to-minute="59" :minute-interval="15" v-model="fromMinutes" />
            </vs-row>
          </div>

        <div class="mx-4 mt-auto mb-3">-</div>

        <div>
          <vs-row vs-w="12">
            <label for="" class="vs-input--label">To</label>
          </vs-row>
          <vs-row vs-w="12" vs-justify="flex-start">
            <hours-dropdown :from-hour="0" :to-hour="23" v-model="toHours" />
            <span class="mx-2 my-auto">:</span>
            <minutes-dropdown :from-minute="0" :to-minute="59" :minute-interval="15" v-model="toMinutes" />
          </vs-row>
        </div>
        </vs-row>
      </vs-col>

      <vs-col vs-lg="2" vs-sm="3" vs-xs="2" >
        <vs-row class="h-full" vs-w="12" vs-align="flex-end">
          <vs-button @click="handleRemoveClick" type="filled" color="danger" icon="remove"
            ></vs-button
          >
        </vs-row>
      </vs-col>
    </vs-row>

    <vs-row vs-w="12" v-if="!limit" vs-align="center">
      <vs-col vs-lg="10" vs-sm="9" vs-xs="10">
        <span class="ml-2 mr-4">No Limit</span>
      </vs-col>

      <vs-col vs-lg="2" vs-sm="3" vs-xs="2">
        <vs-button  @click="handleAddClick" type="filled" color="success" icon="add"
          ></vs-button
        >
      </vs-col>
    </vs-row>
  </vs-col>
</template>

<script>
import * as _ from "lodash";
import moment from "moment";
import "moment-timezone";
import HoursDropdown from './HoursDropdown.vue';
import MinutesDropdown from '../MinutesDropdown.vue';
import { mapGetters } from "vuex";

export default {
  props: {
    limit: {
      type: Object,
    },
    limitType: {
      type: Number
    },
    label: {
      type: String
    }
  },
  components: {
    HoursDropdown,
    MinutesDropdown
  },
  data() {
    return {
    };
  },
  computed: {
    ...mapGetters({
      activeVenueDetails: "marcom/activeVenue",
    }),
    fromHours: {
      get() {
        return this.getHourValueFromLimitTime('openingTime');
      },
      set(value) {
        this.setLimitTimeFromHourValue('openingTime', value);
      }
    },
    fromMinutes: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        let momentDuration = moment.duration(this.limit.openingTime);
        return Number.parseInt(momentDuration.minutes());
      },
      set(value) {
        let minutes = _.padStart(value, 2, '0');
        let momentDuration = moment.duration(this.limit.openingTime);
        let hours = _.padStart(momentDuration.hours(), 2, '0');
        this.limit.openingTime = `${hours}:${minutes}:00`;
      }
    },
    toHours: {
      get() {
        return this.getHourValueFromLimitTime('closingTime');
      },
      set(value) {
        this.setLimitTimeFromHourValue('closingTime', value);
      }
    },
    toMinutes: {
      get() {
        if (this.limit === null || this.limit === undefined) return;
        let momentDuration = moment.duration(this.limit.closingTime);
        return Number.parseInt(momentDuration.minutes());
      },
      set(value) {
        let minutes = _.padStart(value, 2, '0');
        let momentDuration = moment.duration(this.limit.closingTime);
        let hours = _.padStart(momentDuration.hours(), 2, '0');
        this.limit.closingTime = `${hours}:${minutes}:00`;
      }
    }
  },
  methods: {
    handleRemoveClick() {
      setTimeout(() => {
        this.$emit("limit-removed", this.limitType);
      }, 10);

    },
    handleAddClick() {
      setTimeout(() => {
        this.$emit("limit-added", this.limitType);
      }, 10);
    },
    getHourValueFromLimitTime(limitTime){
      let momentDuration = moment.duration(this.limit[limitTime]);
      let hours = momentDuration.hours();
      let fakeUtcMoment = moment.utc().hours(hours);
      let fakeLocalMomentAtVenue = fakeUtcMoment.tz(this.activeVenueDetails.timeZoneInfo.olsonTimeZone);
      let localHours = fakeLocalMomentAtVenue.hours();
      return localHours;
    },
    setLimitTimeFromHourValue(limitTime, value) {
      let fakeLocalMomentAtVenue = moment().tz(this.activeVenueDetails.timeZoneInfo.olsonTimeZone).hours(value);
      let fakeUtcMoment = moment.utc(fakeLocalMomentAtVenue);
      let hours = _.padStart(fakeUtcMoment.hours(), 2, '0');
      let momentDuration = moment.duration(this.limit[limitTime]);
      let minutes = _.padStart(momentDuration.minutes(), 2, '0');
      this.limit[limitTime] = `${hours}:${minutes}:00`;
    }
  },
};
</script>
